import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  standalone: false,
  selector: 'app-grid-cell-toggle-switch',
  templateUrl: './grid-cell-toggle-switch.component.html',
  styleUrls: ['./grid-cell-toggle-switch.component.scss']
})
export class GridCellToggleSwitchComponent implements ICellRendererAngularComp {
  @Input() isChecked: boolean = false;
  @Input() isDisabled: boolean = false;
  params: any;

  agInit(params: any): void {
    this.params = params;
    this.isChecked = !!params.value;
    this.isDisabled = params.isDisabled || false;
  }

  refresh(params: any): boolean {
    this.agInit(params);
    return true;
  }

  toggle() {
    if (this.isDisabled) return;
    if (this.params.onToggle) {
      this.params.onToggle(this.isChecked, this.params);
      return;
    }
    this.isChecked = !this.isChecked;
    if (this.params && this.params.node && this.params.colDef) {
      this.params.node.setDataValue(this.params.colDef.field, this.isChecked);
    }
  }
}